import React from 'react';

import { QuickMenuComponent } from 'components';

function List() {
  return <QuickMenuComponent.Manage />;
}

export default List;
